// src/components/Footer.js
import React, { useState, useEffect } from 'react';
import './Footer.css';
import linkedinIcon from '../Assets/images/linkedin-icon.svg';
import githubIcon from '../Assets/images/github-icon.svg';
import envelopeIcon from '../Assets/images/envelope-icon.svg';
import phoneIcon from '../Assets/images/phone-icon.svg';


// Build timestamp - this gets set at build time
const BUILD_TIMESTAMP = new Date().toISOString();

const Footer = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      // Show footer when user has scrolled to within 100px of the bottom
      const threshold = 100;
      const isNearBottom = scrollTop + windowHeight >= documentHeight - threshold;

      setIsVisible(isNearBottom);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial state

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  /**
   * Get the last deployment date
   *
   * This function retrieves the build/deployment timestamp that was set
   * during the build process by scripts/set-build-time.js
   *
   * Flow:
   * 1. npm run build triggers scripts/set-build-time.js
   * 2. Script sets REACT_APP_BUILD_TIME in .env.production
   * 3. This function reads that timestamp and formats it
   * 4. Footer displays "Last deployed: [formatted date]"
   *
   * This means the date updates automatically with each deployment,
   * no manual updates needed!
   */
  const getBuildDate = () => {
    // Primary: Use the build timestamp set by our build script
    const buildTimestamp = process.env.REACT_APP_BUILD_TIME;

    if (buildTimestamp) {
      const buildDate = new Date(buildTimestamp);
      return buildDate.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    }

    // Fallback: Use the timestamp from when this file was bundled
    // This ensures we always have a date, even if the env var isn't set
    return new Date(BUILD_TIMESTAMP).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const lastUpdated = getBuildDate();

  return (
    <footer className={`footer ${isVisible ? 'visible' : ''}`}>
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h4>Contact</h4>
            <div className="contact-links">
              <a href="mailto:hello@raulco.org" className="contact-link">
                <img src={envelopeIcon} alt="Email" className="contact-icon" />
                hello@raulco.org
              </a>
              <a href="tel:+17603496770" className="contact-link">
                <img src={phoneIcon} alt="Phone" className="contact-icon" />
                +1 (760) 349-6770
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Connect</h4>
            <div className="social-links">
              <a href="https://www.linkedin.com/in/raulco" target="_blank" rel="noopener noreferrer" className="social-link">
                <img src={linkedinIcon} alt="LinkedIn" className="social-icon" />
                LinkedIn
              </a>
              <a href="https://github.com/RaulCo4" target="_blank" rel="noopener noreferrer" className="social-link">
                <img src={githubIcon} alt="GitHub" className="social-icon" />
                GitHub
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Info</h4>
            <div className="footer-info">
              <p className="last-updated">
                Last deployed: October 16,2025 {/*Last deployed: {lastUpdated}*/}
              </p>
              <p className="footer-tagline">
                Turning Chaos into Efficient Systems
              </p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 Raul Correa. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
